/**
 * Tracking configuration for Meta Pixel and Google Analytics
 * This file provides a centralized location for tracking configuration
 */

const trackingConfig = {
  // Meta (Facebook) Pixel Configuration
  meta: {
    pixelId: process.env.REACT_APP_META_PIXEL_ID || '',
    // Additional Meta Pixel settings
    autoConfig: true,
    debug: process.env.NODE_ENV === 'development'
  },
  
  // Google Analytics Configuration
  googleAnalytics: {
    measurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID || '',
    // Additional GA settings
    sendPageView: true,
    debug: process.env.NODE_ENV === 'development'
  },
  
  // General tracking settings
  general: {
    // Enable/disable all tracking
    enabled: process.env.REACT_APP_TRACKING_ENABLED !== 'false',
    // Log tracking events to console in development
    debugMode: process.env.NODE_ENV === 'development',
    // Track only public forms
    publicFormsOnly: true
  }
};

export default trackingConfig;